import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetInvoiceApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<{ invoiceNumber: string, customerNumber?: string; }, GetInvoiceApiParameter, InvoiceModel>;

export const PopulateApiParameterExtension: HandlerType = props => {
    props.apiParameter = {
        invoiceNumber: props.parameter.invoiceNumber,
        customerNumber: props.parameter.customerNumber,
        expand: ["invoiceLines"],
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);